
import { SET_FROM_DATE, SET_TO_DATE, SEARCH_PARAMS } from "../utils/constants/redux";

const initialState = {
  fromDate: null,
  toDate: null,
  searchParams: "",
};

const dateReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FROM_DATE:
      return { ...state, fromDate: action.payload };

    case SET_TO_DATE:
      return { ...state, toDate: action.payload };

    case SEARCH_PARAMS:
      return { ...state, searchParams: action.payload };

    default:
      return state;
  }
};

export default dateReducer;
